// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

// 短信&电话消息发送时间云控
export function getMessageTimeConfig(data = {}) {
  return request('/admin/v1/message/timeConfig', {
    method: 'POST',
    data,
  })
}
